type Props = {
  className?: string;
  height?: string;
  width?: string;
};

const MouseScroll = ({
  className = '',
  height = '24',
  width = '24',
}: Props) => (
  <svg
    focusable={false}
    className={className}
    fill='none'
    height={height}
    width={width}
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect
      height='18.5'
      rx='6.25'
      stroke='#000'
      strokeWidth='1.5'
      width='12.5'
      x='5.75'
      y='2.75'
    />
    <circle cx='12' cy='8' fill='#000' r='2' />
  </svg>
);

export default MouseScroll;
